import Icon1 from "@assets/icons/Icon";
import theme from "@theme/index";
import { CSSProperties, JSX, useEffect, useRef, useState } from "react";

interface MenuInceptionProps {
  label: string;
  children?: JSX.Element | JSX.Element[];
  size?: "medium" | "small" | "large";
  name: string;
}

export default function MenuInception({
  label,
  children,
  size = "medium",
  name,
}: MenuInceptionProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [openLeft, setOpenLeft] = useState<boolean>(false);
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) {
      setVisible(true);
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        const submenuWidth = 200;
        const spaceRight = window.innerWidth - rect.right;
        setOpenLeft(spaceRight < submenuWidth + 16);
      }
    } else {
      const timeout = setTimeout(() => setVisible(false), 200);
      return () => clearTimeout(timeout);
    }
  }, [open]);

  return (
    <div className="relative" ref={triggerRef}>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        className={`
        ${size === "small" ? "px-1.5 py-1" : size === "medium" ? "px-2 pr-4 py-1.5 text-h3" : "px-3 py-2 text-h2"}
        flex flex-row gap-2 w-full items-center hover:bg-gray-100 rounded-lg cursor-pointer`}
      >
        <Icon1
          name={name}
          size={size === "small" ? 16 : size === "medium" ? 20 : 22}
          color="black"
        />
        <div className="font-medium text-black">{label}</div>
      </div>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`
                      ${visible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-90"}
            absolute ${openLeft ? "right-full -mr-4" : "left-full -ml-4"} top-0 z-50 w-200 flex flex-col transition-all duration-200 text-shadow_50 border-1 border-shadow_10 bg-white p-2 shadow-xl rounded-lg`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
